import React, { useEffect } from 'react';
import { GeneralTable } from '../shared/Table/GeneralTable';
import {
    QuotationData,
    QuotationsHeadCellContent,
} from '../../models/quotations/Quotations';
import { QuotationsTableRow } from './QuotationsTableRow';
import { useTranslation } from 'react-i18next';
import { QUOTATION_HEAD_CELLS } from '../../utils/constans/tableHeads/quotationTableHeadCells';
import useQuotationSWR from '../../hooks/quotations/useQuotationsSWR';
import { Box } from '@mui/material';
import { TableLoadingLayout } from '../layouts/LoadingLayouts/TableLoadingLayout';

export const QuotationsTable = () => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS',
    });
    const { quotes, isLoading, isError, forceRefresh } = useQuotationSWR();

    const tableHeadSettings = {
        translateNs: 'quotations',
        translatePrefix: 'QUOTATIONS.TABLE_HEAD',
        selectable: false,
        headContent: QUOTATION_HEAD_CELLS,
    };

    const tableToolbarSettings = {
        translateNs: 'quotations',
        translatePrefix: 'QUOTATIONS.TABLE_TOOLBAR',
    };

    const filterTerm = (search) => {
        return quotes.filter((elem) => {
            return (
                elem.id.toString().includes(search) ||
                elem.buyer.name.toLowerCase().includes(search.toLowerCase())
            );
        });
    };

    const refreshItems = () => {
        forceRefresh().then();
    };

    useEffect(() => {
        forceRefresh();
    }, []);

    return (
        <>
            {isError && <Box>{t('LOADING_ERROR')}</Box>}
            {isLoading && <TableLoadingLayout />}
            {!isLoading && quotes && (
                <GeneralTable<QuotationData, QuotationsHeadCellContent>
                    fullList={quotes}
                    rowComponent={QuotationsTableRow}
                    filterTerm={filterTerm}
                    defaultOrderBy={'id'}
                    defaultOrder={'desc'}
                    selectHandleId={'id'}
                    tableHeadSettings={tableHeadSettings}
                    tableToolbarSettings={tableToolbarSettings}
                    forceRefresh={refreshItems}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};
